import { useStyles } from '@archipro-design/aria';
import { RichTextEditorNodeStyling } from '../RichTextStyling.style';

/**
 * Displays rich text for Page Builder modules.
 */
const RichTextDisplay = ({ contentHTML }: { contentHTML?: string }) => {
    const { css } = useStyles();
    // Apparently this is here for SSR reasons.
    const createMarkup = (html?: string) => ({ __html: html || '' });

    return (
        <div
            className={`${css(RichTextEditorNodeStyling)} cms-inline-html`}
            dangerouslySetInnerHTML={createMarkup(contentHTML)}
        />
    );
};

export default RichTextDisplay;
